import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  ButtonTab,
  Container,
  ContainerPages,
  Menu,
  OptionsContainer,
} from "./styles";
import DadosPessoais from "./DadosPessoais/dadosPessoais";
import DependentesList from "./ListarDependentes/ListarDependentes";
import FichaFinanceiraPage from "./FichaFinanceira/FichaFinanceira";
import MovimentacaoPage from "./Movimentacao/Movimentacao";
import { GetContribuinteDto } from "../../../shared/dtos/Contribuinte.dto";
import { GetDependenteDto } from "../../../shared/dtos/Dependente.dto";
import DadosFinanceirosList from "./DadosFinanceiros/DadosFinanceiros";
import contribuinteService from "../../../services/ContribuinteService";
import { Spinner } from "react-bootstrap";
import { useAuth } from "../../../AuthContext/AuthContext";
import { PermissoesEnum } from "../../../shared/enum/permicao.enum";
import { ModulosEnum } from "../../../shared/enum/modulos.enum";

const emptyContribuinte: GetContribuinteDto = {
  id: 0,
  cpfCin: "",
  nome: "",
  sexo: 0,
  rg: null,
  dataNascimento: null,
  cep: "",
  endereco: "",
  numeroResidencial: null,
  complementoEndereco: null,
  bairro: "",
  cidade: "",
  uf: "",
  email: null,
  telefoneResidencial: null,
  telefoneComercial: null,
  telefoneRecado: null,
  celular: "",
};

const ContribuinteTabs: React.FC = () => {
  const { checkPermission } = useAuth();
  const editContribuinteOnly = checkPermission(
    ModulosEnum.CONTRIBUINTE,
    PermissoesEnum.ESCRITA
  );

  const editDadosPessoaisOnly: boolean = checkPermission(
    ModulosEnum.DADOS_PESSOAIS,
    PermissoesEnum.ESCRITA
  );

  const editMovimentacaoOnly: boolean = checkPermission(
    ModulosEnum.MOVIMENTACOES,
    PermissoesEnum.ESCRITA
  );

  const editDependentesOnly: boolean = checkPermission(
    ModulosEnum.DEPENDENTES,
    PermissoesEnum.ESCRITA
  );

  const editDadosFinanceirosOnly: boolean = checkPermission(
    ModulosEnum.DADOS_FINANCEIROS,
    PermissoesEnum.ESCRITA
  );

  const editFichaFinanceiraOnly: boolean = checkPermission(
    ModulosEnum.FICHA_FINANCEIRA,
    PermissoesEnum.ESCRITA
  );

  const readDadosPessoaisOnly: boolean = checkPermission(
    ModulosEnum.DADOS_PESSOAIS,
    PermissoesEnum.LEITURA
  );

  const readMovimentacaoOnly: boolean = checkPermission(
    ModulosEnum.MOVIMENTACOES,
    PermissoesEnum.LEITURA
  );

  const readDependentesOnly: boolean = checkPermission(
    ModulosEnum.DEPENDENTES,
    PermissoesEnum.LEITURA
  );

  const readDadosFinanceirosOnly: boolean = checkPermission(
    ModulosEnum.DADOS_FINANCEIROS,
    PermissoesEnum.LEITURA
  );

  const readFichaFinanceiraOnly: boolean = checkPermission(
    ModulosEnum.FICHA_FINANCEIRA,
    PermissoesEnum.LEITURA
  );

  const checkOpenTab = () => {
    if (editDadosPessoaisOnly || readDadosPessoaisOnly) {
      setSelectTab(0);
      return;
    }
    if (editMovimentacaoOnly || readMovimentacaoOnly) {
      setSelectTab(3);
      return;
    }
    if (editDependentesOnly || readDependentesOnly) {
      setSelectTab(1);
      return;
    }
    if (editDadosFinanceirosOnly || readDadosFinanceirosOnly) {
      setSelectTab(2);
      return;
    }
    if (editFichaFinanceiraOnly || readFichaFinanceiraOnly) {
      setSelectTab(4);
      return;
    }
  };

  const location = useLocation();
  const navigate = useNavigate();
  const contribuinteToEdit = location.state?.contribuinte || null;

  const [contribuinte, setContribuinte] = useState<GetContribuinteDto>(
    contribuinteToEdit || emptyContribuinte
  );
  const [selectTab, setSelectTab] = useState<number>(0); // Inicializa com 0
  const [isNewContribuinte, setIsNewContribuinte] = useState<boolean>(
    !location.state?.contribuinte || false
  );
  const disableTabs = location.state?.disableTabs || false;
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [newFlow, setNewFlow] = useState<boolean>(
    !location.state?.contribuinte || false
  );

  const [newDependenteData, setNewDependenteData] =
    useState<GetDependenteDto>();
  const [cancelFutureInstallmentsIds, setCancelFutureInstallmentsIds] =
    useState<number[]>([]);

  const handleSelectTab = (index: number) => {
    setSelectTab(index);
  };

  const getContribuinteData = async () => {
    await contribuinteService
      .getContribuinteById(contribuinteToEdit.id)
      .then((response) => {
        setContribuinte(response);
      })
      .catch((error) => {
        console.error(error);
      });
    setIsLoading(false);
  };

  useEffect(() => {
    checkOpenTab();
    if (contribuinteToEdit) {
      getContribuinteData();
    } else {
      setIsLoading(false);
    }
  }, [contribuinteToEdit]);

  // const handleFlowComplete = () => {
  //   if (newFlow) {
  //     Swal.fire({
  //       title: "O que deseja fazer agora?",
  //       text: "Deseja Revisar os Dados Pessoais ou Permanecer em Ficha Financeira?",
  //       icon: "question",
  //       showConfirmButton: true,
  //       confirmButtonText: "Sim, Revisar",
  //       showDenyButton: true,
  //       denyButtonText: "Não, Permanecer na Ficha Financeira",
  //       showCancelButton: false,
  //       allowOutsideClick: false,
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         // Navegação direta para /contribuinte com selectedTab: 0 e desabilita outras abas
  //         navigate(`/contribuinte`, {
  //           state: {
  //             contribuinte,
  //             selectedTab: 0,
  //             isNewContribuinte: false,
  //             disableTabs: true, // Adiciona flag para desabilitar abas
  //           },
  //           replace: true,
  //         });
  //         setSelectTab(0); // Força a seleção da aba de Dados Pessoais
  //         setIsNewContribuinte(false);
  //         setNewFlow(false);
  //       } else if (result.isDenied) {
  //         // Se escolher não revisar, apenas atualiza o estado e permanece na página atual
  //         setIsNewContribuinte(false);
  //         setNewFlow(false);
  //       }
  //     });
  //   }
  // };

  return (
    <>
      {!isLoading ? (
        <Container>
          <Menu
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <OptionsContainer
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              <ButtonTab
                onClick={() => {
                  handleSelectTab(0);
                }}
                active={selectTab === 0}
                disabled={
                  newFlow ||
                  (disableTabs && selectTab !== 0) ||
                  !readDadosPessoaisOnly
                }
              >
                Dados Pessoais
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(3);
                }}
                active={selectTab === 3}
                disabled={newFlow || disableTabs || !readMovimentacaoOnly}
              >
                Movimentação
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(1);
                }}
                active={selectTab === 1}
                disabled={newFlow || disableTabs || !readDependentesOnly}
              >
                Dependentes
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(2);
                }}
                active={selectTab === 2}
                disabled={newFlow || disableTabs || !readDadosFinanceirosOnly}
              >
                Dados Financeiros
              </ButtonTab>
              <ButtonTab
                onClick={() => {
                  handleSelectTab(4);
                }}
                active={selectTab === 4}
                disabled={newFlow || disableTabs || !readFichaFinanceiraOnly}
              >
                Ficha Financeira
              </ButtonTab>
            </OptionsContainer>
          </Menu>

          {/* {contribuinte?.nome && ( // Verifica se o contribuinte e o nome existem
        <ContribuinteContainer>
          Contribuinte: <ContribuinteName>{contribuinte.nome}</ContribuinteName>
        </ContribuinteContainer>
      )} */}

          <ContainerPages>
            {(() => {
              switch (selectTab) {
                case 0:
                  return (
                    <DadosPessoais
                      contribuinteEdited={contribuinte}
                      setContribuinteEdited={setContribuinte}
                      onTabChange={setSelectTab}
                      isNewContribuinte={isNewContribuinte}
                      setIsNewContribuinte={setIsNewContribuinte}
                      setContribuinteTab={setContribuinte}
                      editOnly={editContribuinteOnly && editDadosPessoaisOnly}
                    />
                  );
                case 1:
                  return (
                    <DependentesList
                      contribuinteData={contribuinte!}
                      isNewContribuinte={isNewContribuinte}
                      setSelectedTab={setSelectTab}
                      setNewDependente={setNewDependenteData}
                      newFlow={newFlow}
                      editOnly={editContribuinteOnly && editDependentesOnly}
                    />
                  );
                case 2:
                  return (
                    <DadosFinanceirosList
                      contribuinteData={contribuinte!}
                      setSelectedTab={setSelectTab}
                      setCancelFutureInstallmentsIds={
                        setCancelFutureInstallmentsIds
                      }
                      newFlow={newFlow}
                      setNewFlow={setNewFlow}
                      editOnly={
                        editContribuinteOnly && editDadosFinanceirosOnly
                      }
                    />
                  );
                case 3:
                  return (
                    <MovimentacaoPage
                      contribuinteData={contribuinte}
                      setContribuinteData={setContribuinte}
                      isNewContribuinte={isNewContribuinte}
                      setIsNewContribuinte={() => setIsNewContribuinte(false)}
                      newDependenteData={newDependenteData}
                      setNewDependenteData={setNewDependenteData}
                      setSelectedTab={setSelectTab}
                      newFlow={newFlow}
                      setNewFlow={setNewFlow}
                      editOnly={editContribuinteOnly && editMovimentacaoOnly}
                    />
                  );
                case 4:
                  return (
                    <FichaFinanceiraPage
                      idContribuinte={contribuinte.id!}
                      cancelFutureInstallmentsIds={cancelFutureInstallmentsIds}
                      setCancelFutureInstallmentsIds={
                        setCancelFutureInstallmentsIds
                      }
                      editOnly={editContribuinteOnly && editFichaFinanceiraOnly}
                    />
                  );
                default:
                  return null;
              }
            })()}
          </ContainerPages>
        </Container>
      ) : (
        <Container>
          <Spinner animation="border" role="status" />
        </Container>
      )}
    </>
  );
};

export default ContribuinteTabs;
